import { Col, Row } from '@geberit/gdds';

// styles
import styles from './image-gallery.module.scss';

// types
import type { WrapperProps } from '../types';

// utils
import { useIsDesktop } from 'components/App/SizeProvider';
import { classNameBuilder } from 'utils/classNameBuilder';

export function Wrapper({ children, imageGallery, itemsPerRow }: Readonly<WrapperProps>) {
  const isDesktop = useIsDesktop();

  const centeredClassName = imageGallery?.length === 3 && styles.centerRow;

  return (
    <Row className={classNameBuilder(centeredClassName, styles.negativeMargin)}>
      {/* // when desktop text begins with text -> extra Col for spacing} */}
      {isDesktop && imageGallery.length <= 2 && <Col size={[4, 8, 2]} />}
      <Col size={[4, 8, isDesktop && imageGallery.length <= 2 ? 10 : 12]}>
        <div
          className={classNameBuilder(
            styles.itemsWrapper,
            itemsPerRow === '4' ? styles.fourItemsPerRow : styles.threeItemsPerRow,
          )}
        >
          {children}
        </div>
      </Col>
    </Row>
  );
}
